import PlaqueStructure from '../../function/PlaqueStructure';
function Input (props) {
    return (
        <>
           
               
                    {
                        (props.focus == 1) ? (
                            <input
                                id={props.dash}
                                tabIndex={props.tab}
                                maxLength={props.maxLength}
                                type={props.type}
                                value={props.value} 
                                name={props.name}
                                onChange={props.onchange}
                                className="form-control form-control-lg shadow-none border-right"
                                placeholder={props.placeholder}
                                autoFocus
                                onKeyUp={(e) => PlaqueStructure(e)}
                                disabled={props.disabled}
                                
                                
                            />
                        ) : (
                            <input
                                tabIndex={props.tab}
                                type={props.type}
                                value={props.value} 
                                name={props.name}
                                onChange={props.onchange}
                                className="form-control form-control-lg shadow-none border-right"
                                placeholder={props.placeholder}
                            />
                        )
                    }
                    
                    {
                        (props.errorName) ? (
                        <span className="help-block fw-bold d-inline-block mt-2">
                            <small className='text-danger validate-error'>{ props.errorName }</small>
                        </span>
                    ):''}
            </>
      
    )
}

export default Input;